import React, {useEffect, useRef} from 'react';
import {
  Avatar,
  Button, Chip, Dialog,
  DialogActions, DialogContent, DialogTitle,
} from "@mui/material";
import {withStyles} from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import {FileDrop} from "react-file-drop";
import AttachmentIcon from "@mui/icons-material/Attachment";
import FileDownload from "js-file-download";
import {download} from "../../utils/api";

const styles = () => ({
  paper: {
    maxWidth: '90%',
    margin: 'auto',
    marginTop: '2rem',
    overflow: 'hidden',
  },
  toolbar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  block: {
    display: 'block',
  },
  contentWrapper: {
    margin: '16px 16px',
  },
});

function AddAttachmentDialog(props) {
  const { classes, activity, confirmationHandler } = props;
  const [attachments, setAttachments] = React.useState(activity && activity.attachments ? activity.attachments : []);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setAttachments(activity.attachments);
  }, [activity]);

  const fileInputRef = useRef(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setAttachments([]);
    setOpen(false);
  };

  const handleConfirm = () => {
    confirmationHandler('attachments', attachments);
    handleClose();
  };

  const onTargetClick = () => {
    fileInputRef.current.click()
  }

  const onFileInputChange = (event) => {
    const { files } = event.target;
    setAttachments([
      ...attachments,
      ...files
    ]);
  }

  const handleDeleteAttachment = (fileToDelete) => {
    setAttachments(attachments.filter(file => file !== fileToDelete));
  };

  return (
      <div>
        <Button variant="outlined" color="secondary" sx={{fontSize: 14, mt: 1}} onClick={handleClickOpen}>
          Manage attachment(s)
        </Button>
        <Dialog fullWidth={true} maxWidth={'sm'} className={classes.dialog} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Manage attachment(s)</DialogTitle>
          <DialogContent>
            <input
                onChange={onFileInputChange}
                ref={fileInputRef}
                type="file"
                multiple="multiple"
                style={{display:'none'}}
            />
            { attachments && attachments.length > 0 && attachments.map(((file, index) => (
                <Chip
                    onClick={() => download(file.uuid).then((response) => {
                      FileDownload(response.data, file.filename);
                    })}
                    key={index}
                    sx={{margin: 1}}
                    avatar={
                      <Avatar>
                        {file.name ? file.name.slice(file.name.lastIndexOf('.') + 1) : file.filename.slice(file.filename.lastIndexOf('.') + 1)}
                      </Avatar>}
                    label={file.name ? file.name : file.filename}
                    onDelete={() => handleDeleteAttachment(file)}
                    deleteIcon={<CloseIcon />}
                />
            )))}
            <div style={{ backgroundColor: '#EEEEEE', borderRadius: '5px', border: '1px solid #EEEEEE', width: 550, color: '#666666', padding: 20 }}>
              <FileDrop
                  onDrop={(files) => {
                    setAttachments([...attachments, ...files]);
                  }}
                  onTargetClick={onTargetClick}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  margin: '16px 16px',
                }}>
                  <AttachmentIcon sx={{ fontSize: 24, marginRight: 1 }} />
                  <span>Drop one or multiple documents here for documentation!</span>
                </div>

              </FileDrop>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" size="small">
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="primary" size="small">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
  );
}

export default withStyles(styles)(AddAttachmentDialog)